export const tokens = {
  radius: {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 14,
  },
  heights: {
    blocRow: 40,
    lineRow: 36,
    editRow: 40,
    stickyBar: 56,
    btnDefault: 36,
    btnSmall: 32,
    iconBtn: 44,
    speedDialTrigger: 48,
    speedDialMini: 40,
    speedDialPerson: 32,
    bandeau: 32,
    desktopSegmented: 28,
    inputField: 40,
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
  },
  motion: {
    donutSweep: 900,
    segmentPush: 250,
    waterfallSteps: 800,
    waterfallSubtotals: 500,
    lineChartDraw: 900,
    scoreGauge: 1200,
    drillBarsGrow: 400,
    toastDismiss: { success: 3000, error: 0, warning: 4000, info: 3000, neutral: 2500 },
  },
  cascadeIndent: {
    bloc: 16,
    domain: 24,
    category: 36,
    lineUnderCategory: 52,
    lineUnderDomain: 48,
    simpleBlockLine: 28,
  },
} as const;
